import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserLogsService } from '@app/services/userlogs/userlogs.service';
import { environment } from 'src/environments/environment';
function getCookie(name: string): string | null {
  const matches = document.cookie.match(new RegExp(
    `(?:^|; )${name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1')}=([^;]*)`
  ));
  return matches ? decodeURIComponent(matches[1]) : null;
}

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    let headers = request.headers;

    //if url contains https://suscripcion.desarrollo.wnpower.host send req without X-XSRF-TOKEN nor withCredentials
    if (request.url.includes(environment.urlExternalGateway)) {
      return next.handle(request);
    }

    const xsrfToken = getCookie('XSRF-TOKEN');

    if (xsrfToken) {
      headers = headers.set('X-XSRF-TOKEN', xsrfToken);
    }

    const req = request.clone({
      withCredentials: true,
      headers
    });

    return next.handle(req);
  }
}
